import React from 'react';
import './system-compatibility.scss';
import Table from '../Table';
import { useTranslation } from 'react-i18next';

const SystemCompatibility = () => {
	const { t } = useTranslation();

	const columns = [
		{
			heading: `${t('type')}`,
			accessor: 'type',
		},
		{
			heading: `${t('minimum')}`,
			accessor: 'minimum'
		},
		{
			heading: `${t('recommended')}`,
			accessor: 'recommended',
		}
	]
	const systemRequirements = [
		{
			type: t('internet_connection'),
			minimum: t('wifi_connection'),
			recommended: t('wired_connection')
		},
		{
			type: `${t('pc_users')}/${t('mac_users')}`,
			minimum: `${t('windows_8')}/${t('macos_10_13')}`,
			recommended: `${t('windows_10')}/${t('macos_10_15')}`
		},
		{
			type: t('cpu'),
			minimum: t('cpu_min_requirement'),
			recommended: t('cpu_recommended_requirement')
		},
		{
			type: t('webcam'),
			minimum: t('640x480_resolution'),
			recommended: t('1280x720_resolution')
		},
		{
			type: t('internet_download_speed'),
			minimum: t('1_mbps'),
			recommended: t('12_mbps'),
		},
		{
			type: t('internet_upload_speed'),
			minimum: t('1_mbps'),
			recommended: t('3_mbps')
		},
		{
			type: t('ram'),
			minimum: t('ram_min_requirement'),
			recommended: t('ram_recommended_requirement')
		},
		// {
		// 	type: 'connectivity_ports'),
		// 	minimum: 'connectivity_ports_min_requirement'),
		// 	recommended: 'connectivity_ports_recommended_requirement')
		// },
		{
			type: t('screen_resolution'),
			minimum: t('1366_x_768'),
			recommended: t('1920_x_1080_and_above')
		},
		{
			type: t('chromebook_users'),
			minimum: t('chromebook_users_min_requirement'),
			recommended: t('chromebook_users_recommended_requirement')
		},
	];

	return (
		<>
			<div className='srft-container'>
				<div className='srft-wrapper'>
					<h1>
						{t('system_compatibility')}
					</h1>
					<p>{t('system_compatibility_desc')}</p>

					<div className='srft-table'>
						<Table
							column={columns}
							data={systemRequirements}
							showPagination={false}
							onSortedList={() => null}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default SystemCompatibility;

